/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl';
import cx from 'classnames';
import Button from 'components/common/Button';
import { getRootURL } from 'utils/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getRejectedApplicationLink } from 'actions/loan';

const keyPointsUpsellAU = ['repayments', 'payments', 'applying'];

const backToHomeFooterButtonConfig = {
  url: getRootURL(),
  messageId: 'offer.submit.backhome',
};

const propTypes = {
  errorMessage: PropTypes.string.isRequired,
  backToIncome: PropTypes.func.isRequired,
  productType: PropTypes.string,
};

const LoanError = ({
  errorMessage, backToIncome, productType,
}) => {
  const intl = useIntl();
  const id = useSelector((state) => state.authentication.id);
  const firstName = useSelector((state) => state.authentication.firstName);
  const lastName = useSelector((state) => state.authentication.lastName);
  const dateOfBirth = useSelector((state) => state.authentication.dateOfBirth);
  const msisdn = useSelector((state) => state.authentication.msisdn);
  const email = useSelector((state) => state.authentication.email);
  const creditApplication = useSelector((state) => state.loan.customer.creditApplication);
  const dispatch = useDispatch();
  const defaultTitle = intl.formatHTMLMessage({ id: 'offer.rejected.default.title' });
  const defaultCaption = intl.formatHTMLMessage({ id: 'offer.rejected.default.caption' });
  const defaultDescription = intl.formatHTMLMessage({ id: 'offer.rejected.default.description' });
  const isLoanRejected = errorMessage.startsWith('offer.rejected.');
  const descriptionClasses = cx({
    'txt-large': true,
    'txt-left': COUNTRY === 'AU' && INCREASE_APP,
  });
  const headingClasses = cx({
    'txt-light': MOBILE_WALLET,
  });
  const titleClasses = cx({
    'loan-form__step-title loan-form__step-title--small loan-form__step-title--top-margin': true,
    'loan-form__step-title--top-margin__with_icon': COUNTRY !== 'LV',
    'loan-form__step-title--relative': COUNTRY === 'LV',
  });
  const isUpgrade = INCREASE_APP && productType === 'CREDIT_LINE';
  const isUpsell = INCREASE_APP && productType === 'INSTALLMENT';
  const errorDescription = (
    <FormattedHTMLMessage
      id={`${errorMessage}.description`}
      defaultMessage={defaultDescription}
      tagName={COUNTRY === 'AU' && isUpsell ? 'strong' : undefined}
    />
  );

  const handleRejectionButtonClick = () => {
    const userData = {
      ref: id,
      firstName,
      lastName,
      dateOfBirth,
      msisdn: msisdn && msisdn.replace(/^\+61/, '0'),
      email,
      employer: creditApplication?.employer?.name,
    };

    dispatch(getRejectedApplicationLink(userData));
  };

  return (
    <div className="loan-form loan-form--centered-content">
      <div className="container container--mobile-fullWidth">
        {isLoanRejected
          && (
            <div className="loan-form__step loan-form__step--space-top-bottom txt-center">
              {COUNTRY === 'FI'
                ? <span className="icon icon--error-neutral" />
                : COUNTRY !== 'LV' && <span className="icon icon--sad-face" />}
              <h1 className={titleClasses}>
                <FormattedHTMLMessage
                  id={`${errorMessage}.title`}
                  defaultMessage={defaultTitle}
                />
              </h1>
            </div>
          )}
        <div className="loan-form__step-body txt-center">
          {(COUNTRY !== 'AU' || INCREASE_APP)
            && (
              <>
                <h3 className={headingClasses}>
                  <FormattedHTMLMessage
                    id={`${errorMessage}.caption`}
                    defaultMessage={defaultCaption}
                  />
                </h3>
                {!MOBILE_WALLET && <br />}
              </>
            )}
          <p className={descriptionClasses}>
            {MOBILE_WALLET
              && (
                <FormattedMessage
                  id={`${errorMessage}.description`}
                  defaultMessage={defaultDescription}
                >
                  {(text) => (
                    <span>{text.replace(/<([^>]+)>/ig, '')}</span>
                  )}
                </FormattedMessage>
              )}
            {!MOBILE_WALLET && isUpgrade && (
              <h3 className="txt-center">
                {errorDescription}
              </h3>
            )}
            {!MOBILE_WALLET && !isUpgrade && errorDescription}
          </p>
          {COUNTRY === 'AU' && isUpsell
            && (
              <ul className="txt-left">
                {keyPointsUpsellAU.map((keyPoint) => (
                  <li key={keyPoint}>
                    <FormattedMessage id={`offer.rejected.body.${keyPoint}`} />
                  </li>
                ))}
              </ul>
            )}
        </div>
        {!MOBILE_WALLET
          && (
            <div className="loan-form__footer loan-form__footer--center">
              {errorMessage === 'offer.rejected.affordability_limit'
                ? (
                  <Button
                    onClick={backToIncome}
                    type="button"
                    className="btn--wide"
                  >
                    <FormattedMessage id="navigation.back.to.application" />
                  </Button>
                )
                : (
                  <>
                    {COUNTRY === 'AU' && !INCREASE_APP ? (
                      <button className="btn btn--wide" onClick={handleRejectionButtonClick}>
                        <FormattedHTMLMessage id="navigation.other.loans" />
                      </button>
                    ) : (
                      <a className="btn btn--wide" href={backToHomeFooterButtonConfig.url}>
                        <FormattedHTMLMessage id={backToHomeFooterButtonConfig.messageId} />
                      </a>
                    )}
                  </>
                )}
            </div>
          )}
      </div>
    </div>
  );
};

LoanError.propTypes = propTypes;

export default LoanError;
